{
  "export": {
    "viewport": "Экспорт видимой области",
    "graph": "Экспорт графа",
    "json": "Экспорт JSON"
  },
  "action": {
    "recenter": "Центрировать"
  }
}